import { useState, useEffect, useRef } from 'react'
import ReactQuill from 'react-quill-new'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { RotatingLines } from "react-loader-spinner"
import axios from 'axios'
import { sostituisci } from '../../redux/creaEvento'
import DivBottom from '../userNotAuth/components/divBottom'

function ConfirmEditEvento() {
    let redux = useSelector((state) => state.creaEvento.value)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const grid = { display: 'grid', gridTemplateColumns: '7rem 1fr', gap: '0px' }

    const [msgProgress, setMsgProgress] = useState({ string: null, response: null })//barra del loader dopo submit 
    const [opzioniEvento, setOpzioniEvento] = useState()

    const ospiti = useRef()// array di appoggio per layout ospiti
    const numOspiti = [1, 2, 3, 4, 5]// NUMERO MASSIMO DI OSPITI

    setOspiti()
    function setOspiti() {
        let arrOspiti = []
        numOspiti.forEach(index => {
            const nm = "ospite" + index
            redux[nm] && arrOspiti.push(redux[nm])// redux[nm] sarebbe redux.ospite1 (se index = 1)
        })
        ospiti.current = arrOspiti
        redux = { ...redux, ospiti: arrOspiti.join('ç') }// se torno indietro ho gli ospiti aggiornati
    }
    async function create() {
        setMsgProgress({ string: 'Caricamento in corso...', response: null })
        redux = { ...redux, emailUser: localStorage.getItem('email') }
        try {
            // chiamata a server per update in mysql dell'evento modificato
            // eslint-disable-next-line no-unused-vars
            const res1 = await axios.post(`/editEvento`, redux)
        } catch (err) { setMsgProgress({ ...msgProgress, response: '*** Problemi con il server...riprova ***', string: null }); console.error(err); return }

        setTimeout(() => {
            setMsgProgress({ ...msgProgress, string: null })
            navigate('/modificaEvento', { replace: true })
        }, 2000)
    }
    useEffect(() => {
        if (!redux.id || !localStorage.getItem('idUser')) navigate('/')
        if (redux.opzioniEvento) {
            if (redux.opzioniEvento.length !== 0) {
                let stringa = ''
                redux.opzioniEvento.split(',').forEach((elem, index) => {
                    switch (elem) {
                        case "artisti": stringa += 'Artisti di strada, '; break
                        case "truccabimbi": stringa += 'Truccabimbi, '; break
                        case "parcheggio": stringa += 'Parcheggio gratuito, '; break
                        case "navetta": stringa += 'Navetta, '; break
                        case "mercatini": stringa += 'Mercatini, '; break
                        case "standGastronomici": stringa += 'Stand Gastronomici, '; break
                        case "streetFood": stringa += 'Street Food, '; break
                        case "areaTavoli": stringa += 'Area tavoli, '; break
                        case "birraArtigianale": stringa += 'Birra artigianale, '; break
                        case "musica": stringa += 'Musica Live, '; break
                        case "djSet": stringa += 'Dj set,  '; break
                        case "centroStorico": stringa += 'Centro storico visitabile, '; break
                        case "addobbi": stringa += 'Addobbi scenografici, '; break
                        case "attrazioniBambini": stringa += 'Attrazioni per bambini, '; break
                        case "liscio": stringa += 'Ballo liscio, '; break
                        case "gruppo": stringa += 'Balli di gruppo, '; break
                        case "scuolaDiBallo": stringa += 'Scuola di ballo '; break
                        default:
                    }
                }); setOpzioniEvento(stringa)
            }
        }
    }, [redux])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    useEffect(() => { console.log('redux:', redux.ospiti) }, [redux])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        {/* <AuthProvider /> */}

        <div className='bodyPadding'>
            <h3 style={{ margin: '7rem 0 1rem 0', display: 'inline-block' }}>Riepilogo dell'evento</h3>
            <button className='btn btn-primary' style={{ marginLeft: '1em' }} onClick={create}>Avanti</button>

            {msgProgress.string &&
                <h5 style={{ margin: '0 0 1em 0' }}>
                    <RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' />
                    <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}</span>
                </h5>
            }

            <div className='container' style={{ marginBottom: '0rem' }}>
                <div style={grid}>
                    <div>Titolo:</div> <div>{redux.titolo}</div>
                </div>
                {redux.sottotitolo &&
                    <div className='mt-3'>
                        <div>SottoTitolo:</div>
                        <div style={{ border: '1px solid lightgrey', padding: '5px', margin: '0 0 15px 10px', borderRadius: '5px' }}>
                            {redux.sottotitolo}
                        </div>
                    </div>
                }
                <div style={grid}>
                    <div>Tipologia:</div> <div>{redux.tipologia}</div>
                    <div>Regione:</div> <div>{redux.regione}</div>
                    <div>Città:</div> <div>{redux.città}</div>
                    <div>Location:</div> <div>{redux.comune}</div>
                </div>
                {redux.indirizzo &&
                    <div style={grid}>
                        <div>Indicazioni:</div> <div>{redux.indirizzo}</div>
                    </div>
                }
                <div style={grid}>
                    <div>Provincia:</div> <div>{redux.provincia.toUpperCase()}</div>
                    <div>Email:</div> <div>{redux.email}</div>
                </div>
                {redux.telefono && <div style={grid}>
                    <div>Telefono:</div> <div>{redux.telefono}</div>
                </div>}
                <div style={grid}>
                    <div>Inizio evento:</div> <div>{redux.dataInizio.split("-").reverse().join("-")}
                        {redux.oraInizio && <span> alle {redux.oraInizio}</span>}
                    </div>
                    <div>Fine evento:</div> <div>{redux.dataFine.split("-").reverse().join("-")}
                        {redux.oraFine && <span> alle {redux.oraFine}</span>}
                    </div>
                </div>
                {opzioniEvento &&
                    <div><hr />
                        <h5>Opzioni Evento:</h5>
                        <div style={{ marginLeft: '5px' }}>{opzioniEvento}</div><hr />
                    </div>
                }
                {redux.biglietto ?
                    <div style={grid}>
                        <div>COSTO BIGLIETTO:</div> <div>€ {redux.prezzo}</div>
                        <div></div> <div><i>{redux.opzioniBiglietto}</i></div>
                    </div> : redux.noBiglietto ?
                        <div style={grid}>
                            <div>Ingresso:</div> <div>gratuito</div>
                        </div>
                        : redux.sito ?
                            <div style={grid}>
                                <div>BIGLIETTO:</div> <div>Vai al sito</div>
                            </div> : null
                }

                <h5 className='mt-5'>DESCRIZIONE:</h5>
                <ReactQuill className="textarea-quill"
                    value={redux.descrizione}
                    theme="snow"
                    modules={{
                        toolbar: false
                    }}
                />
                {redux.url &&
                    <div>
                        <h5 className='mt-3'>Sito web/URL:</h5>
                        <p style={{ fontSize: 'small' }}>{redux.url.substring(0, 50)}...</p> <hr />
                    </div>
                }
                {/* -------------------- OSPITI ---------------------- */}
                {ospiti.current.length !== 0 &&
                    <div>
                        <div className='mt-3' style={grid}>
                            <div>OSPITI:</div>
                            <div style={{ marginLeft: '-60px' }}>
                                {ospiti.current.map((elem, index) => {
                                    return (
                                        <span key={index}> <i>{elem}</i>
                                            {index + 1 !== ospiti.current.length && <span>,</span>}
                                        </span>
                                    )
                                })
                                }
                            </div>
                        </div><hr />
                    </div>
                }
                {redux.fb &&
                    <div>
                        <h5 className='mt-3'>URL FB:</h5>
                        <p style={{ fontSize: 'small' }}>{redux.fb.substring(0, 50)}...</p> <hr />
                    </div>
                }
                {redux.youTube &&
                    <div>
                        <h5 className='mt-3'>URL YOUTUBE:</h5>
                        <p style={{ fontSize: 'small' }}>{redux.youTube.substring(0, 50)}...</p> <hr />
                    </div>
                }
                {redux.infoOrganizzatore &&
                    <div className='mt-4'>
                        <h6>INFO ORGANIZZATORE:</h6>
                        <p><i>{redux.infoOrganizzatore}</i></p><hr />
                        <p><i>{redux.email}</i></p><hr />
                    </div>
                }

                <p className='mt-4'>IMMAGINI CARICATE ⇓</p>
                <div className='gridAddEvento2 mt-3'>
                    {redux.foto &&
                        redux.foto.map((elem, index) => (
                            <div key={index} style={{ textAlign: 'center' }}>
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${elem}`} style={{ maxWidth: '110px', maxHeight: '80px' }} alt='' />
                            </div>
                        ))}
                </div>
                {redux.foto.length === 0 && <p style={{ marginLeft: '10px' }}>Nessuna immagine caricata</p>}
                <br />

                <div className='mt-2'>
                    <p>VIDEO CARICATO ⇓</p>
                    {redux.video ?
                        <div>
                            {/* ------------- preview del video NON modificato proveniente da MYSQL (saved in AWS) ------------ */}
                            <video src={`https://leuro-bucket.s3.amazonaws.com/video/${redux.video}`} id={'videoPreview'}
                                style={{ width: '144px', height: '80px', borderRadius: '5px' }} controls />
                        </div> : <p style={{ marginLeft: '10px' }}>Nessun video caricato</p>
                    }
                </div><hr />

                {parseInt(redux.pubblicitàFB) === 1 ?
                    <div className='mt-3'>◾ L'evento sarà condiviso su FB alla pagina ZonaEventi</div> :
                    <div className='mt-3'>◾ L'evento NON sarà condiviso su FB alla pagina ZonaEventi</div>
                }

                {msgProgress.string &&
                    <h5 className='mt-3'>
                        <span style={{ marginLeft: '1rem', color: 'navy' }}>{msgProgress.string}<RotatingLines strokeColor='navy' strokeWidth='5' animationDuration='5' width='26' /></span>
                    </h5>
                }
                {msgProgress.response && <p className='mt-3' style={{ color: 'red' }}>{msgProgress.response}</p>}

                <div className='mt-5'>
                    <button type='button' className='btn btn-secondary' onClick={() => {
                        dispatch(sostituisci(redux))
                        navigate('/editEvento2', {
                            replace: true,
                            state: { fromConfirm: true }//per gestire le foto nella pagina precedente
                        })
                    }}>
                        Indietro
                    </button>
                    <button type='button' className='btn btn-primary' onClick={create} style={{ marginLeft: '3rem' }}>
                        Avanti
                    </button>
                </div>
            </div>
        </div>
        <DivBottom />
    </>)

}
export default ConfirmEditEvento